import type { GetServerSideProps } from "next";

import { loadPageWithGlobal } from "@shared/api";
import type { GlobalType } from "@shared/content-types/types";

import type { ArticleType } from "@/_pages/article/model";
import { ArticlePage } from "@/_pages/article/ui";
import { getBlogPost } from "@/_pages/blog/api";

type Params = {
  slug: string;
};

type PageProps = {
  cms: ArticleType;
  global?: GlobalType | null;
};

// Шаблон как у /travelguide: та же страница статьи и форма из глобальных настроек
const Page = (props: PageProps) => {
  const { cms, global } = props;

  return <ArticlePage article={cms} formSettings={global?.feedbackForm} />;
};

export const getServerSideProps: GetServerSideProps<{}, Params> = async (
  context,
) => {
  const { res } = context;
  const { slug } = context.params!;

  return await loadPageWithGlobal(
    async () => {
      const { article } = await getBlogPost(slug);

      return {
        ...article,
      };
    },
    { res },
  );
};

export default Page;
